import { connectedStore } from '../../store';
import selectors from '../selectors';

const getGlobalBySource = (source) => {
  const store = connectedStore.get();
  const state = store.getState();

  return selectors.getGlobalBySource(state, source);
};

export default getGlobalBySource;
